import { PaginationType } from "@/types"
import { apiFetch, formatDate } from "../utils"
import { postActivityLog } from "./log"
import { PaymentHistoryType } from "@/types/payment"
const billingUrl = `himo-billing/`

export async function getConsumerPaymentHistoy(
  consumerId: number,
  startDate: string,
  endDate: string,
  size: number,
  page: number,
  search: string,
): Promise<PaginationType<PaymentHistoryType>> {
  const response = await apiFetch(
    `${billingUrl}payment-history/${consumerId}?from_date=${startDate}&to_date=${endDate}&size=${size}&page=${page}&search=${search}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (!response.ok) {
    throw new Error(`Error fetching consumer payment history: ${response.statusText}`)
  }
  const jsonResponse = await response.json()
  return jsonResponse
}